import { ApiResourceTableColumnFactory } from "../../../hooks/useApiResourceTable";
import React from "react";
import {UpdateGroupFarmDto} from "../../../models/domain/UpdateGroupFarmDto";
import {FarmLinkStatus} from "../../../comps/farm/farm-link-status/FarmLinkStatus";
import {
  UpdateGroupFarmLinkButton
} from "../../../comps/update-group/update-group-farm-link-button/UpdateGroupFarmLinkButton";
import {UpdateGroupDto} from "../../../models/domain/UpdateGroupDto";

export const UpdateGroupAssignedFarmsColumnsFactory = (updateGroup: UpdateGroupDto | undefined): ApiResourceTableColumnFactory<UpdateGroupFarmDto> =>
  (() => {
  return [
    {
      accessorKey: 'farmId',
      header: 'Farm ID',
    },
    {
      accessorKey: "farmName",
      header: 'Farm Name',
    },
    {
      accessorKey: "ecoHerdVersion",
      header: 'EcoHerd Version',
    },
    {
      accessorKey: 'updateGroupId',
      header: 'Update group | Product Version',
      Cell: ({row}) => <>
        <FarmLinkStatus farm={row.original}/>
      </>,
    },
    {
      accessorKey: 'updateGroupId',
      id: 'farmAssignment',
      header: 'Assign',
      Cell: ({row}) => <>
        <UpdateGroupFarmLinkButton key={`assigned-${row.original.farmId}`} farm={row.original} updateGroup={updateGroup}/>
      </>,
      enableColumnFilter: false,
      enableSorting: false,
    },
  ];
})